import { useState } from "react";
import FeaturedInfo from "../components/FeaturedInfo/FeaturedInfo";
import Navbar from "../components/Navbar/Navbar";
import Team from "../components/Team/Team";
import Historia from "../container/Historia/Historia";
import Tienda from "../container/Tienda/Tienda";

const Home = () => {
  const [activeSection, setActiveSection] = useState("matches");

  const renderSection = () => {
    switch (activeSection) {
      case "teams":
        return <Team />;
      case "historia":
        return <Historia />;
      case "tienda":
        return <Tienda />;
      case "news":
        return <div>Noticias (pendiente)</div>;
      case "watch":
        return <div>Vídeos (pendiente)</div>;
      case "matches":
      default:
        return <FeaturedInfo />;
    }
  };

  return (
    <>
      <Navbar
        activeSection={activeSection}
        onChangeSection={setActiveSection}
      />
      {renderSection()}
    </>
  );
};

export default Home;
